export enum CancelSiteStatusEnum {
  STUCK = 'stuck',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  BACKUP_NOT_FOUND = 'backup_not_found',
  BACKUP_TOO_LARGE = 'backup_too_large',
}
